import React, { useState } from "react";
import "./TechStack.css";
import { 
  SiFlutter, SiDart, SiReact, SiTypescript, SiJavascript, 
  SiFigma, SiFirebase, SiNodedotjs, SiGithub 
} from "react-icons/si";
import { FaRobot } from "react-icons/fa";

const TechStack = () => {
  const data = [
    { name: "Flutter", icon: <SiFlutter color="#02569B" /> },
    { name: "Dart", icon: <SiDart color="#0175C2" /> },
    { name: "React Native", icon: <SiReact color="#61DAFB" /> },
    { name: "TypeScript", icon: <SiTypescript color="#3178C6" /> },
    { name: "JavaScript", icon: <SiJavascript color="#F7DF1E" /> },
    { name: "React", icon: <SiReact color="#61DAFB" /> },
    { name: "Node.js", icon: <SiNodedotjs color="#339933" /> },
    { name: "Firebase", icon: <SiFirebase color="#FFCA28" /> },
    { name: "Git & GitHub", icon: <SiGithub color="#FFF" /> },
    { name: "Figma", icon: <SiFigma color="#F24E1E" /> },
    { name: "UIPath / RPA", icon: <FaRobot color="#FA4616" /> },
    { name: "State Management", icon: null },
    { name: "REST APIs", icon: null },
    { name: "CI/CD", icon: null },
    { name: "Agile Workflow", icon: null },
  ];

  const [showMoreTechStack, setMoreTechStack] = useState(9);

  const loadMore = () => {
    setMoreTechStack((prev) => prev + 6);
  };
  return (
    <div className="container techstack-section" id="stack">
      <div className="section-title">
        <h2>Tech Stack & Skills</h2>
        <span className="line"></span>
      </div>

      <div className="row technology-grid">
        {data.slice(0, showMoreTechStack).map((item, index) => (
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 tech-col" key={index}>
            <div className={`tech-card glass-panel ${index < 2 ? 'tech-featured' : ''}`}>
              <div className="tech-icon">
                {item.icon ? item.icon : <span className="tech-dot"></span>}
              </div>
              <p className="tech-name">{item.name}</p>
            </div>
          </div>
        ))}
      </div>

      {showMoreTechStack >= data.length ? null : (
        <div className="load-more-container">
          <button className="load-more primary-btn" onClick={loadMore}>
            Load Mastered Skills
          </button>
        </div>
      )}
    </div>
  );
};

export default TechStack;
